/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { BackendService } from '../../../../../utils/src/lib/sysque-backend/backend.service';
import { LocalStorageService } from '../../../../../utils/src/lib/local-storage/local-storage.service';
import { ICableTraySystemFacade } from '../../../../../data-access/src/lib/domain/facades-models/cable-tray-system-facade-interface';
import { GlobalConstants } from '../../constants/global-constants';
import { Injectable } from '@angular/core';
import { SelectedPanelDataItem } from '../../models/selected-panel-data-item';
import { SysqueElectricalState } from '../../models/sysque-electrical-state';

@Injectable({ providedIn: 'root' })
export class CableTraySystemFacade implements ICableTraySystemFacade {
  constructor(private localStorageService: LocalStorageService, private backendService: BackendService) {}

  applyPanelDataLogic(panelData: SelectedPanelDataItem, isWireFillSpec: boolean): void {
    this.backendService.messageHandler.sendRequestAsync(GlobalConstants.ApplyPanelDataLogic, [
      panelData,
      isWireFillSpec,
    ]);
  }

  getLocalStorage(key: string): string | SysqueElectricalState {
    return this.localStorageService.getStorage(key);
  }
}
